import {
  MarketingSection,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";

const COPY = [
  "When fans choose to share their information, you can see who is supporting your music and build a direct relationship beyond a play count.",
  "Use that connection to keep fans informed about future releases, exclusive content, and the next experience you create for them.",
];

const POINTS = [
  "0% Lutely commission",
  "Pay what you want",
  "Direct fan relationships",
];

export default function SellFanData() {
  return (
    <MarketingSection
      className="bg-white"
      innerClassName="grid grid-cols-[1fr_0.88fr] items-center gap-[72px] max-[980px]:grid-cols-1 max-[680px]:gap-[42px]"
    >
      <div>
        <SectionKicker>Know your audience</SectionKicker>
        <SectionTitle>Turn a purchase into a relationship.</SectionTitle>
        {COPY.map((text) => (
          <p
            key={text}
            className="mt-[22px] max-w-[650px] font-open-sans text-[18px] leading-[1.65] text-[#59637A]"
          >
            {text}
          </p>
        ))}
        <small className="mt-[25px] block font-open-sans text-[13px] leading-[1.55] text-[#7D8496]">
          Customer information is shared only when the fan opts in.
        </small>
      </div>
      <div className="rounded-[26px] border border-[#DCE2EF] bg-marketing-soft p-[42px] max-[680px]:p-[30px]">
        <p className="font-permanent-marker text-[24px] leading-[1.1] text-[#148B6C]">
          The real opportunity
        </p>
        <h3 className="mt-[19px] font-figtree text-[35px] font-[850] leading-[1.08] tracking-[-0.04em] text-marketing-ink">
          Maximize the value of every fan.
        </h3>
        <p className="mt-[18px] font-open-sans text-[17px] leading-[1.65] text-[#59637A]">
          Streaming helps people discover and revisit your music. Lutely gives
          the fans who want more a place to own it, explore it, and support you
          directly.
        </p>
        <div className="mt-[26px] flex flex-wrap gap-[9px]">
          {POINTS.map((point) => (
            <span
              key={point}
              className="rounded-full bg-white px-3 py-[9px] font-figtree text-[12px] font-[750] leading-none text-marketing-ink"
            >
              {point}
            </span>
          ))}
        </div>
      </div>
    </MarketingSection>
  );
}
